import styled from "styled-components";
import { Icon } from "@ebscois/react-component-library";

// Show Navigation on Destktop (when not scrolled)
export const Container = styled.div`
  background-color: ${({ theme }) => theme.colors.secondary.base};
  ${({ isHidden }) => isHidden && `display: none;`}
`;

export const InnerContainer = styled.div`
  margin: 0 auto;
  max-width: 1440px;
`;

export const Label = styled.span`
  & sup {
    font-size: ${(props) => props.theme.font.size.xxs};
    vertical-align: super;
  }
`;

export const StyledIcon = styled(Icon)`
  margin-left: ${({ theme }) => theme.space.xs};
`;
